import { create } from 'zustand';

const initialState = {
  currency: null,
  minimum: null,
  preset: null
};

export const usePriceStore = create((set) => ({
  ...initialState,
  
  setPriceCurrency: (currency) => set({ currency }),
  setMinimumPrice: (minimum) => set({ minimum }),
  setPresetPrice: (preset) => set({ preset }),
  resetPrice: () => set(initialState)
}));

export const usePriceCurrency = () => usePriceStore(state => state.currency);
export const useMinimumPrice = () => usePriceStore(state => state.minimum);
export const usePresetPrice = () => usePriceStore(state => state.preset);

export const useSetPriceCurrency = () => usePriceStore(state => state.setPriceCurrency);
export const useSetMinimumPrice = () => usePriceStore(state => state.setMinimumPrice);
export const useSetPresetPrice = () => usePriceStore(state => state.setPresetPrice);
export const useResetPrice = () => usePriceStore(state => state.resetPrice);
